
import { QuiltySubscriptionPlanType } from "@gsx/common";
import { SubscriptionPlanType } from "@gsx/common/src/types/models/subscription";
import { Container } from "inversify";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { IndividualSubscriptionRedirectModalStore } from "../../../../../common/src/subscription-quote/IndividualSubscriptionRedirectModalStore";
import { SubscriptionQuoteModalStore } from "../../../../../common/src/subscription-quote/SubscriptionQuoteModalStore";
import { PaymentService } from "../../../../../landing/src/utility/payment/PaymentService";

@Component({
    components: {},
})
export default class SubscriptionUpgradeButton extends Vue {
    @Inject("container") container!: Container;
    @Prop({ default: "global" }) subscriptionType!: "quilty" | "global";
    @Prop({ default: SubscriptionPlanType.Individual }) subscriptionNeeded!:
        | SubscriptionPlanType
        | QuiltySubscriptionPlanType;
    readonly modalStore: IndividualSubscriptionRedirectModalStore = this.container.get(
        IndividualSubscriptionRedirectModalStore,
    );
    readonly subscriptionQuoteModalStore: SubscriptionQuoteModalStore = this.container.get(
        SubscriptionQuoteModalStore,
    );
    readonly paymentService: PaymentService = this.container.get(PaymentService);

    conversionText: any = {
        [`global_${SubscriptionPlanType.Individual}`]: "GSE Individual",
        [`global_${SubscriptionPlanType.Enterprise}`]: "GSE Enterprise",
        [`quilty_${QuiltySubscriptionPlanType.Basic}`]: "Quilty Basic",
        [`quilty_${QuiltySubscriptionPlanType.Intelligence}`]: "Quilty Intelligence",
        [`quilty_${QuiltySubscriptionPlanType.Enterprise}`]: "Quilty Enterprise",
    };

    onUpgrade() {
        if (
            this.subscriptionType === "global" &&
            this.subscriptionNeeded === SubscriptionPlanType.Individual
        ) {
            this.needsSubscription();
        } else if (
            this.subscriptionType === "global" &&
            this.subscriptionNeeded === SubscriptionPlanType.Enterprise
        ) {
            this.needsEnterpriseSubscription();
        } else if (
            (this.subscriptionType === "quilty" &&
                this.subscriptionNeeded === QuiltySubscriptionPlanType.Basic) ||
            this.subscriptionNeeded === QuiltySubscriptionPlanType.Intelligence ||
            this.subscriptionNeeded === QuiltySubscriptionPlanType.Enterprise
        ) {
            try {
                this.paymentService.purchasePlan(this.subscriptionNeeded);
            } catch (e) {}
        }
    }

    needsSubscription() {
        this.modalStore.open();
    }

    needsEnterpriseSubscription() {
        this.subscriptionQuoteModalStore.open();
    }
}
